import { LOGOUT } from "@/components/access/ducks/Actions"
import { RECEIVE_SYNONYMS } from "@/components/search/internal/ducks/Actions"

const defaultState = {
  synonyms: "",
  indexTimeSynonyms: "",
}

const internalSearchReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case RECEIVE_SYNONYMS:
      return {
        ...oldState,
        synonyms: action.params.synonyms,
        indexTimeSynonyms: action.params.indexTimeSynonyms,
      }
    case LOGOUT:
      return defaultState

    default:
      return oldState
  }
}

export default internalSearchReducer
